import { Pipe, PipeTransform } from '@angular/core';

import { ApplicationUtilsService, ApiValueType } from '@util-services';
import { isEmptyValue } from '@helpers';

@Pipe({
  name: 'numberValue',
  standalone: false,
})
export class NumberValuePipe implements PipeTransform {
  constructor(public appUtils: ApplicationUtilsService) {}

  async transform(waarde: ApiValueType): Promise<string> {
    return this.transformSync(waarde);
  }

  transformSync(waarde: ApiValueType): string {
    if (isEmptyValue(waarde)) {
      return waarde as string;
    }
    return this.appUtils.formatValueBeforeScreen(waarde);
  }
}
